/* import __COLOCATED_TEMPLATE__ from './manage-fin-identity.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Signature {
  Args: {
    heading: string;
    description: string;
  };
}

export default class ManageFinIdentity extends Component<Signature> {
  @service declare router: RouterService;

  @action manageFinIdentity() {
    let settingsUrl = this.router.urlFor('apps.app.settings.ai-automation.fin-ai-agent');
    safeWindowOpen(settingsUrl, '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::ManageFinIdentity': typeof ManageFinIdentity;
    'standalone/common/manage-fin-identity': typeof ManageFinIdentity;
  }
}
